export const breakpoints = {
  mobile: '@media (max-width: 768px)',
}
